import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const STORAGE_KEY = "phm_consent_accepted_v1";

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const accepted = localStorage.getItem(STORAGE_KEY);
      if (!accepted) setVisible(true);
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    } catch (e) {
      console.error("Failed to save consent preference:", e);
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 px-4 pb-4"
      role="dialog"
      aria-live="polite"
      aria-label="Privacy and cookie consent"
      data-testid="consent-banner"
    >
      <div className="max-w-5xl mx-auto bg-[#111111] border border-[var(--border)] rounded-xl shadow-2xl p-5 md:p-6 flex flex-col md:flex-row md:items-center gap-4">
        <div className="flex items-start gap-3 flex-1">
          <Cookie className="w-5 h-5 text-[var(--red)] mt-0.5 shrink-0" />
          <p className="text-sm text-[var(--text-2)] leading-relaxed">
            We use essential cookies and basic analytics to improve your experience. By
            continuing to use this site, you acknowledge and accept our{" "}
            <Link to="/compliance#privacy" className="link-red">Privacy Statement</Link> and{" "}
            <Link to="/compliance#terms" className="link-red">Terms of Use</Link>.
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <Link
            to="/compliance"
            className="btn-ghost text-sm px-4 py-2"
            data-testid="consent-learn-more"
          >
            Learn more
          </Link>
          <button
            type="button"
            onClick={accept}
            className="btn-red text-sm px-5 py-2"
            data-testid="consent-accept"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
